import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { PageForbiddenSvg } from '../../assets/images';
import { Background } from '../../stories/Background';
import { Button } from '../../stories/Button';
import { Header } from '../../stories/Header';

interface ForbiddenPageProps {
  data?: {
    errorCode?: string;
  };
}

export const ForbiddenPage: React.FC<ForbiddenPageProps> = ({ data }) => {
  const __ = useTranslation().t;

  return (
    <>
      <Header type="logo-only" />
      <Background>
        <div className="oejr-utility-page">
          <Container>
            <Row className="justify-content-center align-items-center">
              <Col sm={12} md={6} className="text-center">
                <PageForbiddenSvg />
              </Col>
              <Col sm={12} md={6}>
                <div className="oejr-utility-page-text-container">
                  <h1 className="oejr-utility-page-header">{__('opsSecretDoor')}</h1>
                  <p className="oejr-utility-page-description">
                    {__('restrictedAccessOrNoPermissionPageGoBack')}
                  </p>
                  <p className="oejr-utility-page-error-code">
                    {__('errorCode', { errorCode: data?.errorCode ?? '403' })}
                  </p>
                </div>

                <Button label={__('goBack')} onClick={() => window.history.back()} />
              </Col>
            </Row>
          </Container>
        </div>
      </Background>
    </>
  );
};
